import { useCallback, useEffect, useState } from 'react';
import { Megaphone } from 'lucide-react';
import { api } from '../lib/api';
import DashboardTab from '../components/marketing/DashboardTab';
import ContentTab from '../components/marketing/ContentTab';
import ListsTab from '../components/marketing/ListsTab';
import EventsTab from '../components/marketing/EventsTab';
import WebsiteTab from '../components/marketing/WebsiteTab';
import DatasheetsTab from '../components/marketing/DatasheetsTab';
import { visibleMarketingTabs } from '../lib/nav-areas.mjs';

// Website & content (the Knowledge & Website area): dashboard, content drafts with approval,
// and the concria.us website records (leads, blog, chatbot). Target lists, events and
// datasheets are hidden in Phase 0 (code kept; see src/lib/nav-areas.mjs).
// Nothing here posts to LinkedIn or sends email; the three partners do that themselves.

const TABS = visibleMarketingTabs().map((t) => [t.key, t.label]);
const TAB_KEYS = new Set(TABS.map(([k]) => k));

export default function MarketingPage() {
  const [tab, setTab] = useState(() => {
    try { const k = localStorage.getItem('mkt_tab'); return TAB_KEYS.has(k) ? k : 'dashboard'; } catch { return 'dashboard'; }
  });
  const [options, setOptions] = useState(null);
  const [error, setError] = useState('');
  const loadOptions = useCallback(() => api.get('/marketing/options').then((o) => { setOptions(o); setError(''); }).catch((e) => setError(e.message)), []);
  useEffect(() => { loadOptions(); }, [loadOptions]);
  const pick = (k) => { setTab(k); try { localStorage.setItem('mkt_tab', k); } catch { /* ignore */ } };

  return (
    <div className="mx-auto max-w-6xl">
      <div className="mb-4">
        <h1 className="flex items-center gap-2 text-xl font-semibold text-[var(--text-primary)]"><Megaphone size={20} /> Website &amp; content</h1>
        <p className="text-sm text-[var(--text-secondary)]">Website leads, blog posts and chatbot documents, LinkedIn and email drafts. Drafts are approved here and posted by hand.</p>
      </div>
      <div className="mb-4 flex flex-wrap gap-1 border-b border-[var(--border)]">
        {TABS.map(([k, l]) => (
          <button key={k} onClick={() => pick(k)} className={`-mb-px border-b-2 px-3 py-2 text-sm ${tab === k ? 'border-primary font-semibold text-[var(--text-primary)]' : 'border-transparent text-[var(--text-secondary)]'}`}>{l}</button>
        ))}
      </div>
      {error && <p className="mb-3 text-sm text-rose-600">{error}</p>}
      {tab === 'dashboard' && <DashboardTab />}
      {/* A failed options request shows its error without an endless Loading message. */}
      {tab === 'content' && (options ? <ContentTab segments={options.segments} /> : !error && <p className="text-sm text-[var(--text-secondary)]">Loading…</p>)}
      {tab === 'lists' && <ListsTab onChanged={loadOptions} />}
      {tab === 'events' && (options ? <EventsTab options={options} /> : !error && <p className="text-sm text-[var(--text-secondary)]">Loading…</p>)}
      {tab === 'website' && (options ? <WebsiteTab options={options} onChanged={loadOptions} /> : !error && <p className="text-sm text-[var(--text-secondary)]">Loading…</p>)}
      {tab === 'datasheets' && <DatasheetsTab />}
    </div>
  );
}
